export const reduceMotion = document.body.hasAttribute('data-reduce-motion')
export const flipDurationMs = reduceMotion ? 0 : 150
